import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=55f4ea49&scoped=true&"
import script from "./Body.vue?vue&type=script&lang=js&"
export * from "./Body.vue?vue&type=script&lang=js&"
import style0 from "./Body.vue?vue&type=style&index=0&id=55f4ea49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4ea49",
  null
  
)

export default component.exports